import { useEffect, useState } from "react";
import axios from "axios";
import you from "../images/boy.png";
import bot from "../images/happy.png";
import LoadingDots from "./LoadingDots";
import LastMenu from './LastMenu'
// Image imports for carousel
import image1 from '../images/premix1.jpg';
import image2 from '../images/premix2.jpg';

const PremixNutrition = () => {
    const [nutritionData, setNutritionData] = useState([]); // Store premix nutrition data
    const [time] = useState(new Date().toLocaleTimeString()); // Time display
    const [index, setIndex] = useState(0); // Index for carousel navigation
    const [loading, setLoading] = useState(true); // Loading state for nutrition data

    useEffect(() => {
        // Fetch premix nutrition data from the backend API
        axios
            .get("https://poultry-chatbot-api.onrender.com/premix_nutrition")  // API to fetch premix nutrition data
            .then((response) => {
                if (response.data?.length > 0) {
                    setNutritionData(response.data); // Set nutrition data
                } else {
                    alert("No Nutrition Data found.");
                }
            })
            .catch((error) => {
                console.error("Error fetching premix nutrition items:", error);
                alert("Failed to fetch nutrition data.");
            })
            .finally(() => setLoading(false)); // Set loading to false after fetching data
    }, []); // Empty dependency array means it runs once on initial render

    // Navigation functions for the carousel
    const moveLeft = () => {
        if (index > 0) setIndex(index - 1);
    };

    const moveRight = () => {
        if (index < nutritionData.length - 1) setIndex(index + 1);
    };

    return (
        <>
            <div className="you-time">
                <img src={you} alt="boy" className="boy" />
                You {time}
            </div>

            <div className="you-message">
                <div className="frame2 animated-frame">Premix Nutrition</div>
            </div>

            {loading ? (
                <div className="frame1 animated-frame">
                    <LoadingDots />
                </div>
            ) : (
                <>
                    <div className="chatbot">
                        <img src={bot} alt="bot" className="bot" />
                        <div className="chatbot-time">{time}</div>
                    </div>

                    <div className="frame1 animated-frame">
                        {nutritionData.length > 0 ? (
                            <div className="carousel-container">
                                <button onClick={moveLeft} className="nav-button">
                                    &#60;
                                </button>

                                {/* Display the premix nutrition item with image and description */}
                                <div className="food-item">
                                    <b style={{ fontSize: '18px' }}>
                                        {nutritionData[index]?.pn_name}
                                    </b>
                                    <br />
                                    <img
                                        src={index % 2 === 0 ? image1 : image2} // Toggle between two images
                                        alt={nutritionData[index]?.pn_name}
                                        className="carousel-image"
                                    />
                                    <p className="description">{nutritionData[index]?.description}</p>
                                </div>

                                <button onClick={moveRight} className="nav-button">
                                    &#62;
                                </button>
                            </div>
                        ) : (
                            <p>No premix nutrition items found.</p>
                        )}
                    </div>
                    <LastMenu />
                </>
            )}
        </>
    );
};

export default PremixNutrition;
